<template>
  <el-row class="number-range">
    <el-col :span="11">
      <el-form-item style="margin-bottom:0">
        <el-input @blur="handleBlur" type="number" min="0" v-model.number="list[0]"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="2" style="text-align: center;">~</el-col>
    <el-col :span="11">
      <el-form-item prop style="margin-bottom:0">
        <el-input @blur="handleBlur" type="number" min="0" v-model.number="list[1]"></el-input>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
export default {
  // 并不是完整的 表单
  name: "NumberRange",
  model: {
    prop: "list",
    event: "change",
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  updated() {
    // console.log("this.list", this.list);
    // 检查负数
  },
  methods: {
    handleBlur() {
      // for (let item of this.list) {
      //   if (item < 0) {
      //     this.$message({
      //       type: "error",
      //       message: "请输入大于0的值",
      //       showClose: true,
      //     });
      //     return;
      //   }
      // }
      // if (this.list[0] > this.list[1]) {
      //   this.$message({
      //     type: "info",
      //     message: "左侧为下限，右侧为上限，上限需要大于下限",
      //     showClose: true,
      //   });
      //   return;
      // }
    },
  },
  watch: {
    list: function (val) {
      this.$emit("change", val);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/base/number-range/index.vue